const theme = {
    color: {
        highlight: "#004ED0",
        background: "#EDF2F9"
    },
    breakpoints: [480, 667, 768, 1024, 1200]
}

export default theme;